import ActionsGenerator from '../../lib/ActionsGenerator'

const generator = new ActionsGenerator('form', '/forms')
const actions = generator.generate()

export default actions
